import {option, Option} from "ts-option";
import {MaterialSearchApiDto} from "../../api/model/rest";

export default class MaterialSearch {
	constructor(public readonly id: string,
		public readonly description: string,
		public readonly price: Option<number>) {}

	static fromJson(json: MaterialSearchApiDto): MaterialSearch {
		return new MaterialSearch(json.id,
			json.description,
			option(json.price)
		);
	}
}